import { FunctionComponent, PropsWithChildren } from "react";
import { ScrollArea as ArkScrollArea } from "@ark-ui/react";
import classNames from "classnames";

import styles from "./scroll-area.module.css";

export const ScrollAreaRoot: FunctionComponent<
  PropsWithChildren<ArkScrollArea.RootProps>
> = ({ children, className, ...props }) => {
  return (
    <ArkScrollArea.Root className={classNames(styles.root, className)} {...props}>
      {children}
    </ArkScrollArea.Root>
  );
};

export const ScrollAreaViewport: FunctionComponent<
  PropsWithChildren<ArkScrollArea.ViewportProps>
> = ({ children, className, ...props }) => {
  return (
    <ArkScrollArea.Viewport className={classNames(styles.viewport, className)} {...props}>
      {children}
    </ArkScrollArea.Viewport>
  );
};

export const ScrollAreaContent: FunctionComponent<
  PropsWithChildren<ArkScrollArea.ContentProps>
> = ({ children, className, ...props }) => {
  return (
    <ArkScrollArea.Content className={classNames(styles.content, className)} {...props}>
      {children}
    </ArkScrollArea.Content>
  );
};

export const ScrollAreaScrollbar: FunctionComponent<
  PropsWithChildren<ArkScrollArea.ScrollbarProps>
> = ({ children, className, ...props }) => {
  return (
    <ArkScrollArea.Scrollbar className={classNames(styles.scrollbar, className)} {...props}>
      {children}
    </ArkScrollArea.Scrollbar>
  );
};

export const ScrollAreaThumb: FunctionComponent<ArkScrollArea.ThumbProps> = ({
  className,
  ...props
}) => {
  return <ArkScrollArea.Thumb className={classNames(styles.thumb, className)} {...props} />;
};

export const ScrollAreaCorner: FunctionComponent<ArkScrollArea.CornerProps> = ({
  className,
  ...props
}) => {
  return (
    <ArkScrollArea.Corner className={classNames(styles.corner, className)} {...props} />
  );
};

interface ScrollAreaProps {
  rootProps?: ArkScrollArea.RootProps;
  viewportProps?: ArkScrollArea.ViewportProps;
  hideScrollbar?: boolean;
}

const ScrollArea = ({
  rootProps,
  viewportProps,
  hideScrollbar,
  children,
}: PropsWithChildren<ScrollAreaProps>) => {
  return (
    <ScrollAreaRoot {...rootProps}>
      <ScrollAreaViewport {...viewportProps}>
        <ScrollAreaContent>{children}</ScrollAreaContent>
      </ScrollAreaViewport>
      {!hideScrollbar && (
        <>
          <ScrollAreaScrollbar orientation="horizontal">
            <ScrollAreaThumb />
          </ScrollAreaScrollbar>
          <ScrollAreaScrollbar orientation="vertical">
            <ScrollAreaThumb />
          </ScrollAreaScrollbar>
        </>
      )}

      <ScrollAreaCorner />
    </ScrollAreaRoot>
  );
};

export default ScrollArea;
